export const recurrency = {
    google: "La récurrence n'est pas gérée pour les rendez-vous Google",
}